module.exports = [
	{
		"title": "Parlons un peu du bro code",
		"img": "https://ablueworld.files.wordpress.com/2010/10/barneysblog_20101004.jpg",
		"id": "1",
		"questions": [
			{
				"text": "Il n'est pas loin de 23h, tu es confortablement installé !  Soirée cocooning avec ta chérie, ton portable se met à sonner ! Le nom de ton pote alias <q>ton gars sûr</q> apparaît sur l’écran ! <w class='bolder'>Que fais-tu ?</w>",
				"img": "https://beautefutee.files.wordpress.com/2015/07/62ad1f79b87dc270d4bdb8691e5e781b.jpg?w=458&h=307",
				"responses": [
					{
						"text": "Tu laisses sonner car le regard lancé par ta moitié te fait comprendre que c’est la meilleure solution",
						"score": 1
					},
					{
						"text": "Il est sérieux lui ?? WTF !",
						"score": 0
					},
					{
						"text": "Bon ma chérie désolé! Mais le devoir m’appelle !",
						"score": 2
					}
				]
			},
			{
				"text": "En plein épisode de la saison 7 de GOT, ton gars sûr (oui encore lui) t’envoie un  texto <q><i>Frérot si on te demande, hier soir j’étais avec toi! Merci :)</i> </q>. <w class='bolder'>Comment réagis tu ?</w>",
				"img": "https://us.res.keymedia.com/files/image/iStock-gameofthrones%20(500%20x%20334).jpg",
				"responses": [
					{
						"text": "OK mec! Mais tu me donnes quoi en échange ?",
						"score": 0
					},
					{
						"text": "Hodor, Hodor, Hodor !!",
						"score": 1
					},
					{
						"text": "Bien évidemment !  On a joué à la PS toute la soirée.",
						"score": 2
					}
				]
			},
			{
				"text": "En compagnie de ton gars sûr (décidément) et fraîchement sorti du barber, autant dire très très frais! Vos regards croisent celui d’une charmante jeune femme qui vous répond par un magnifique sourire...  Non seulement vous réalisez que vous la connaissez mais qu’elle est aussi celle que vous considérez comme pouvant être la mère de vos enfants. <w class='bolder'>Que fais-tu ?</w>",
				"img": "https://www.menshairstyletrends.com/wp-content/uploads/2018/02/tythemasterbarber-360-waves-e1519148275790.jpg",
				"responses": [
					{
						"text": "Grand seigneur tu renonces à elle… Une de perdue dix de... (tu n'y crois pas non plus, mais trop tard).",
						"score": 2
					},
					{
						"text": "Frère t’as une pièce ? OK !  Pile ou face ?",
						"score": 1
					},
					{
						"text": "She’s the one! Chacun pour soi!",
						"score": 0
					}
				]
			},
			{
				"text": "Ton meilleur ami te laisse un message et tu comprends qu’il est dans une galère sans nom. <w class='bolder'>Jusqu'où es-tu prêt à aller pour lui ?</w>",
				"img": "https://media.firerank.com/upload/dli/7240/6_ff31c6.jpg",
				"responses": [
					{
						"text": "Désolé j’ai poney aquatique",
						"score": 0
					},
					{
						"text": "Qu’il commence déjà par me rendre les 100€ qu’il me doit",
						"score": 1
					},
					{
						"text": "Je lui donne mon rein sans hésitation, après tout j’en ai 2",
						"score": 2
					}
				]
			},
			{
				"text": "Sortie de boîte, ton pote peine à tenir debout et bouscule quelques personnes devant l’entrée pour finir à quatres pattes sur le trottoir en train de vider  son estomac.  <br><w class='bolder'>Que fais-tu ?</w>",
				"img": "http://homerite.fr/odh/wp-content/uploads/2015/08/homme-alcool.jpg",
				"responses": [
					{
						"text": "S’il vous plait quelqu’un pourrait l’aider, je suis tout en blanc !",
						"score": 0
					},
					{
						"text": "Dire qu'il n'a bu que du jus de pomme...",
						"score": 1
					},
					{
						"text": "I got your back bro !!",
						"score": 2
					}
				]
			}
		],
		"results": [
			{
				"text": "La notion de camaraderie semble être pour toi un concept totalement abstrait. Néanmoins restons optimiste, cela te laisse une énorme marge de progression. A titre d’exemple la distance entre la terre et la lune pourrait illustrer les efforts que tu auras à fournir… Mais rien n’est perdu demande à Neil Armstrong. C’est d’ailleurs pour cela que nous te décernons le titre de Baby Chaperon.",
				"rank": "bronze"
			},
			{
				"text": "Bienvenue en terre du milieu, car oui pour le coup tu es au milieu (spéciale dédicace à Sauron).. C’est pas super avec le wooow effect, mais c’est bien. S'il s’agissait d’un conseil de classe, la conclusion du conseil serait “Élève intéressé ayant des capacités qui ne demandent qu’à être exploitées, mais peut beaucoup mieux faire”. Haut les coeurs, ici il n’y a pas de bons ou de mauvais élèves juste des personnes bienveillantes, et bonne nouvelle tu en fais partie.  Lorsque Chaperon sera disponible, tu pourras améliorer tes compétences en camaraderie, pour t’encourager nous te décernons le titre de Junior Chaperon.",
				"rank": "silver"
			},
			{
				"text": "Bravo Champion!! On peut dire que tu masterises le concept de camaraderie, tu es par définition “l’ami qui veut du bien”. Si l’on ouvre un dictionnaire il y a de fortes chances qu’à la lettre “A” pour amitié, on trouve ta photo. Tu es sans nul doute une personne fiable et altruiste doté d’un gros coeur. Avoir une personne comme toi dans son entourage est le gage d’une relation authentique et sincère… Nous sommes persuadés que tu feras de belles choses au sein de l’application Chaperon lorsqu’elle sera dans tes mains. Pour toutes ces qualités,  nous te décernons le titre honorifique de master Chaperon.",
				"rank": "gold"
			}
		]
	},
	{
		"title": "Zoom sur la solidarité féminine",
		"img": "https://ablueworld.files.wordpress.com/2010/10/barneysblog_20101004.jpg",
		"id": "2",
		"questions": [
			{
				"text": "Ton homme a invité ses potes à un dîner et s’est lancé le défi de préparer lui même le repas mais ne s'en sort pas. De ton côté, tu as une soirée filles. <w class='bolder'>Sauras-tu partir la conscience tranquille ?</w>",
				"img": "https://brightcove04pmdo-a.akamaihd.net/5316136140001/5316136140001_5538444894001_5511194464001-vs.jpg?pubId=5316136140001&videoId=5511194464001",
				"responses": [
					{
						"text": "Tu prends les devants et fais appel à un traiteur.",
						"score": 2
					},
					{
						"text": "Tu te rappelles qu'au pire tu as de vagues notions de secourisme et qu’une soirée entre filles c’est nettement plus sympa.",
						"score": 0
					},
					{
						"text": "Il te fait de la peine, tu lui proposes ton aide avec tact et diplomatie. Non en fait il te fait juste de la peine et il n’y aura jamais assez de Spasfon pour tout le monde.",
						"score": 1
					}
				]
			},
			{
				"text": "Ta copine t’appelle en panique elle vient de recevoir les chaussures qu’elle a commandé mais ce n’est pas le bon modèle ! Et c’est aujourd’hui qu’elle a ce rendez-vous important, du coup pour compléter sa tenue elle aurait besoin de t’emprunter tes chaussures préférées. <w class='bolder'>Comment réagis-tu ?</w>",
				"img": "https://4.bp.blogspot.com/-rYddE_h0bXE/WdCSlNbObXI/AAAAAAABOj8/HV02D1vqJeUgVlTu1by1VkJXV__pYhHrQCKgBGAs/s1600/sarah-jessica-parker-amazon-mode3.jpg",
				"responses": [
					{
						"text": "J’aurais aimé mais je chausse du 38 et toi du 40",
						"score": 1
					},
					{
						"text": "Avec plaisir ma chérie, je t'emmène mes Loubous (que je n’ai porté qu’une fois lors de l’essayage !)",
						"score": 2
					},
					{
						"text": "T’es sûre que t’as vraiment rien d’autre à te mettre?  La sandale est très tendance ceci dit…",
						"score": 0
					}
				]
			},
			{
				"text": "Tu dois rendre un dossier important dans moins de 2 heures et ta collègue adorée débarque en larmes. <w class='bolder'>Que fais tu ?</w>",
				"img": "https://cap.img.pmdstatic.net/fit/http.3A.2F.2Fprd2-bone-image.2Es3-website-eu-west-1.2Eamazonaws.2Ecom.2Fcap.2F2017.2F05.2F05.2F5509e174-4fb1-4f78-afb4-f88993e916a8.2Ejpeg/750x375/quality/70/5509e174-4fb1-4f78-afb4-f88993e916a8.jpeg",
				"responses": [
					{
						"text": "Je prends le temps d’écouter ses problèmes, j’ai 1h devant moi",
						"score": 2
					},
					{
						"text": "Hmmm… Il n’y avait vraiment personne dans le bureau d’à côté ?",
						"score": 1
					},
					{
						"text": "C’est pas elle qui me paye !",
						"score": 0
					}
				]
			},
			{
				"text": "Tu passes devant ta pâtisserie préférée accompagnée de ta pote, qui depuis quelques mois a entamé un régime. Arrivée à la caisse, elle est sur le point de craquer et demande ton avis. <w class='bolder'>Alors soutien or not soutien ?</w>",
				"img": "https://media-cdn.tripadvisor.com/media/photo-s/09/f3/15/b1/fresson.jpg",
				"responses": [
					{
						"text": "Non ma chérie c’est parfait, prends en même deux !",
						"score": 1
					},
					{
						"text": "Ce ne serait pas raisonnable, tu ruinerais tes efforts, 6 mois c’est pas rien...",
						"score": 2
					},
					{
						"text": "Je t’aurais bien proposé de prendre comme moi mais c’était le dernier.",
						"score": 0
					}
				]
			},
			{
				"text": "Tu es assise au café avec ta copine (oui toujours elle) qui a prévu de te présenter son nouveau copain. Il finit par arriver et tu réalises que non seulement tu le connais mais surtout qu’il est déjà marié ! <w class='bolder'>Que fais-tu ?</w>",
				"img": "https://theundercoverrecruiter.com/wp-content/uploads/2016/04/secret-shhh.jpg",
				"responses": [
					{
						"text": "Motus et bouche cousue, j’ai toujours pas digéré son commentaire sur ma robe, qu'elle se débrouille !",
						"score": 0
					},
					{
						"text": "Je le dénonce sans aucune hésitation",
						"score": 2
					},
					{
						"text": "Pas besoin de faire de scandale, il a peut être divorcé depuis...",
						"score": 1
					}
				]
			}
		],
		"results": [
			{
				"text": "La notion de camaraderie semble être pour toi un concept totalement abstrait. Néanmoins restons optimiste, cela te laisse une énorme marge de progression. A titre d’exemple la distance entre la terre et la lune pourrait illustrer les efforts que tu auras à fournir… Mais rien n’est perdu demande à Neil Armstrong. C’est d’ailleurs pour cela que nous te décernons le titre de Baby Chaperon.",
				"rank": "bronze"
			},
			{
				"text": "Bienvenue en terre du milieu, car oui pour le coup tu es au milieu (spéciale dédicace à Sauron).. C’est pas super avec le wooow effect, mais c’est bien. S'il s’agissait d’un conseil de classe, la conclusion du conseil serait “Élève intéressée ayant des capacités qui ne demandent qu’à être exploitées, mais peut beaucoup mieux faire”. Haut les coeurs, ici il n’y a pas de bons ou de mauvais élèves juste des personnes bienveillantes, et bonne nouvelle tu en fais partie.  Lorsque Chaperon sera disponible, tu pourras améliorer tes compétences en camaraderie, pour t’encourager nous te décernons le titre de Junior Chaperon.",
				"rank": "silver"
			},
			{
				"text": "Bravo Championne!! On peut dire que tu masterises le concept de camaraderie, tu es par définition “l’amie qui veut du bien”. Si l’on ouvre un dictionnaire il y a de fortes chances qu’à la lettre “A” pour amitié, on trouve ta photo. Tu es sans nul doute une personne fiable et altruiste doté d’un gros coeur. Avoir une personne comme toi dans son entourage est le gage d’une relation authentique et sincère… Nous sommes persuadés que tu feras de belles choses au sein de l’application Chaperon lorsqu’elle sera dans tes mains. Pour toutes ces qualités,  nous te décernons le titre honorifique de master Chaperon.",
				"rank": "gold"
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/components/resources/quizz.json
// module id = 1
// module chunks = 0